import { Link } from 'react-router-dom';
import { pricingFaq, ui } from '@/components/pricing/pricingData';
import useWhatsApp from '@/lib/useWhatsApp';
import { generalWaMessage } from '@/components/services/servicesData';

export default function PricingFaq({ lang }) {
  const tx = (o) => o[lang];
  const { waLink } = useWhatsApp();
  return (
    <section className="mt-20 max-w-3xl mx-auto">
      <h2 className="font-inter font-black text-2xl md:text-3xl mb-6 text-center">{tx(ui.faqTitle)}</h2>
      <div className="divide-y divide-border/40 border-y border-border/40">
        {pricingFaq.map((f) => (
          <details key={f.q.en} className="group py-4">
            <summary className="cursor-pointer list-none font-semibold text-foreground flex justify-between gap-4">
              <h3 className="text-base">{tx(f.q)}</h3>
              <span className="text-primary group-open:rotate-45 transition-transform">+</span>
            </summary>
            <p className="text-muted-foreground text-sm mt-3">{tx(f.a)}</p>
          </details>
        ))}
      </div>
      <p className="text-center mt-8 text-sm text-muted-foreground">
        {tx(ui.unsure)}:{' '}
        <Link to="/contact" className="text-primary hover:underline">{lang === 'es' ? 'Contacto' : 'Contact'}</Link>
        {' · '}
        <a href={waLink(generalWaMessage)} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">WhatsApp</a>
      </p>
    </section>
  );
}